import { render, staticRenderFns } from "./M2hAnalytics.vue?vue&type=template&id=b5fd2f08&"
import script from "./M2hAnalytics.vue?vue&type=script&lang=js&"
export * from "./M2hAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports